var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRank = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.765V2.5C14 1.122 12.878 0 11.5 0A2.503 2.503 0 0 0 9 2.5v13.265C7.759 16.595 7 18 7 19.5c0 2.482 2.019 4.5 4.5 4.5s4.5-2.018 4.5-4.5c0-1.498-.76-2.904-2-3.735M11.5 21c-.827 0-1.5-.672-1.5-1.5 0-.65.419-1.199 1-1.407V7.5a.5.5 0 0 1 1 0v10.593a1.5 1.5 0 0 1 1 1.407c0 .828-.674 1.5-1.5 1.5M15.5 3h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1M18.5 7h-3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12h-1a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rank.svg";